import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentOrder } from 'Redux/Order/slice';
import { selectDistanceAndDuration } from 'Redux/Location/slice';
import { useAppDispatch } from 'Redux/store';
import { getRouteDistanceAndDuration } from 'Redux/Location/reducer';
import { resetCurrentDistanceAndDuration } from 'Redux/Location/slice';
import ContentWithBreaks from 'Components/UI/ContentWithBreaks';
import { timestampsToTimeDiff, secondsToMinutesAndHours } from 'Shared/Utils';
import styles from './TransitInfo.module.scss';

interface TransitInfoProps {
  children?: React.ReactNode;
}

export const TransitInfo: React.FC<TransitInfoProps> = ({ children }) => {
  const currentOrder = useSelector(selectCurrentOrder);
  const distanceAndDuration = useSelector(selectDistanceAndDuration);
  const [transitTime, setTransitTime] = useState('');
  const [deliveryTime, setDeliveryTime] = useState('');
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetCurrentDistanceAndDuration());
    };
  }, [dispatch]);

  useEffect(() => {
    if (distanceAndDuration?.durationInSec) {
      setTransitTime(
        secondsToMinutesAndHours(distanceAndDuration?.durationInSec),
      );
    }
  }, [distanceAndDuration]);

  useEffect(() => {
    if (currentOrder) {
      if (Boolean(currentOrder.transit_time) === false) {
        dispatch(
          getRouteDistanceAndDuration({
            coordinateFrom: currentOrder?.coordinate_from || '',
            coordinateTo: currentOrder?.coordinate_to || '',
          }),
        );
      } else {
        setTransitTime(secondsToMinutesAndHours(currentOrder.transit_time));
      }

      const updateDeliveryTime = () => {
        setDeliveryTime(
          timestampsToTimeDiff({
            startTime: new Date(),
            endTime: currentOrder.deliver_date,
          }),
        );
      };
      let intervalID: ReturnType<typeof setInterval>;

      updateDeliveryTime();

      if (deliveryTime === '') {
        intervalID = setInterval(updateDeliveryTime, 1000 * 60 * 5);

        return () => {
          clearInterval(intervalID);
        };
      }
    }
  }, [currentOrder]);

  return (
    <div className={styles.transitInfo}>
      <div className={styles.transitInfo__time}>
        <div className={styles.transitInfo__time_passed}>
          <span className={styles.transitInfo__time__title}>TRANSIT TIME</span>
          <span className={styles.transitInfo__time__value}>
            <ContentWithBreaks content={transitTime} placeholder={true} />
          </span>
        </div>
        <div className={styles.transitInfo__time_left}>
          <span className={styles.transitInfo__time__title}>
            TIME LEFT TO DELIVER
          </span>
          <span className={styles.transitInfo__time__value}>
            <ContentWithBreaks content={deliveryTime} placeholder={true} />
          </span>
        </div>
      </div>

      {children}
    </div>
  );
};
